import { observer } from "mobx-react-lite";

import { CREATE_APPLICATION_STEP_TITLES, usePageStore } from "../create-application-page.lib";

export const CreateApplicationStepTitle = observer(() => {
  const pageStore = usePageStore();
  const activeStep = pageStore?.activeStep ?? "type";
  const stepTitle = CREATE_APPLICATION_STEP_TITLES[activeStep];
  const isTypeStepRequired = activeStep === "type";

  return (
    <h1 className="text-type-common heading-h4 text-[32px] leading-10">
      {stepTitle}
      {isTypeStepRequired && <span className="text-system-error-50"> *</span>}
    </h1>
  );
});
